import React from 'react';
import { Button } from 'antd';
import { BellOutlined, CloseOutlined, ProjectOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { navigateToLink } from '../../utils/approvalCenterNav';
import { getMsgTypeMeta } from '../../config/inboxCategoryMeta';
import '../ApprovalNotify/ApprovalNotifyBanner.css';
import './InboxNotifyBanner.css';

const VARIANT_CLASS = {
  pending: 'pending',
  info: 'info',
  success: 'success',
  warning: 'warning',
  rejected: 'rejected'
};

function renderIcon(msgType, variant) {
  if (msgType?.startsWith('plan_')) return <ProjectOutlined />;
  return <BellOutlined />;
}

function shouldShowContent(item) {
  return Boolean(item.content);
}

const InboxNotifyBanner = ({ items, topOffset = 72, onDismiss, onDismissAll }) => {
  const navigate = useNavigate();

  if (!items?.length) return null;

  return (
    <div className="inbox-notify-stack" style={{ top: topOffset }}>
      {items.map((item) => {
        const meta = getMsgTypeMeta(item.msg_type);
        const variant = VARIANT_CLASS[meta.variant] || 'info';
        const showContent = shouldShowContent(item);

        return (
          <div
            key={item.id}
            className={`approval-notify-banner approval-notify-banner--${variant}`}
          >
            <button
              type="button"
              className="approval-notify-close"
              aria-label="关闭"
              onClick={() => onDismiss(item.id)}
            >
              <CloseOutlined />
            </button>

            <div className="approval-notify-main">
              <div className="approval-notify-icon">
                {renderIcon(item.msg_type, variant)}
              </div>
              <div className="approval-notify-body">
                <div className="approval-notify-tag">{meta.label || '提醒'}</div>
                <div className="approval-notify-title">{item.title}</div>
                {showContent && (
                  <div className="approval-notify-content">{item.content}</div>
                )}
              </div>
            </div>

            <div className="approval-notify-footer">
              <Button
                size="small"
                className="approval-notify-detail-btn"
                onClick={() => {
                  onDismiss(item.id);
                  if (item.link_path) {
                    navigateToLink(navigate, item.link_path);
                    return;
                  }
                  navigate('/messages');
                }}
              >
                查看
              </Button>
            </div>
          </div>
        );
      })}
      {items.length > 1 && (
        <button type="button" className="approval-notify-dismiss-all" onClick={onDismissAll}>
          全部关闭
        </button>
      )}
    </div>
  );
};

export default InboxNotifyBanner;
